import { render, staticRenderFns } from "./DeviceCorrection.vue?vue&type=template&id=0b5d4389&"
import script from "./DeviceCorrection.vue?vue&type=script&lang=js&"
export * from "./DeviceCorrection.vue?vue&type=script&lang=js&"
import style0 from "./DeviceCorrection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports